// extracted by mini-css-extract-plugin
module.exports = {"root":"Slider_root__1mQ0o","slide":"Slider_slide__2XFEA","count-5":"Slider_count-5__3jk9w"};